export const COUNTRY_CODE = [
  { name: 'Denmark', code: '+45' },
  { name: 'United States', code: '+1' },
  { name: 'Canada', code: '+1' },
  { name: 'United Kingdom', code: '+44' },
  { name: 'Australia', code: '+61' },
  { name: 'India', code: '+91' },
  { name: 'China', code: '+86' },
  { name: 'Brazil', code: '+55' },
  { name: 'France', code: '+33' },
  { name: 'Germany', code: '+49' },
  { name: 'Japan', code: '+81' },
  { name: 'South Africa', code: '+27' },
  { name: 'Austria', code: '+43' },
  { name: 'Belgium', code: '+32' },
  { name: 'Bulgaria', code: '+359' },
  { name: 'Croatia', code: '+385' },
  { name: 'Republic of Cyprus', code: '+357' },
  { name: 'Czech Republic', code: '+420' },
  { name: 'Estonia', code: '+372' },
  { name: 'Finland', code: '+358' },
  { name: 'France', code: '+33' },
  { name: 'Greece', code: '+30' },
  { name: 'Hungary', code: '+36' },
  { name: 'Iceland', code: '+354' },
  { name: 'Ireland', code: '+353' },
  { name: 'Italy', code: '+39' },
  { name: 'Latvia', code: '+371' },
  { name: 'Lithuania', code: '+370' },
  { name: 'Luxembourg', code: '+352' },
  { name: 'Malta', code: '+356' },
  { name: 'Netherlands', code: '+31' },
  { name: 'Norway', code: '+47' },
  { name: 'Poland', code: '+48' },
  { name: 'Portugal', code: '+351' },
  { name: 'Romania', code: '+40' },
  { name: 'Slovakia', code: '+421' },
  { name: 'Slovenia', code: '+386' },
  { name: 'Spain', code: '+34' },
  { name: 'Sweden', code: '+46' },
  { name: 'Switzerland', code: '+41' },
  { name: 'Ukraine', code: '+380' },
  { name: 'United Kingdom', code: '+44' },
];

export const COUNTRY_CODE_EXTENDED = [
  {
    country_code: '',
    country_name: 'Select your country code'
  },

  {
    id: 1,
    country_code: '93',
    country_name: 'Afghanistan',
    country_name_short_form: 'AF',
  },
  {
    id: 2,
    country_code: '35818',
    country_name: 'Aland Islands',
    country_name_short_form: 'AX',
  },
  {
    id: 3,
    country_code: '355',
    country_name: 'Albania',
    country_name_short_form: 'AL',
  },
  {
    id: 4,
    country_code: '213',
    country_name: 'Algeria',
    country_name_short_form: 'DZ',
  },
  {
    id: 5,
    country_code: '1684',
    country_name: 'American Samoa',
    country_name_short_form: 'AS',
  },
  {
    id: 6,
    country_code: '376',
    country_name: 'Andorra',
    country_name_short_form: 'AD',
  },
  {
    id: 7,
    country_code: '244',
    country_name: 'Angola',
    country_name_short_form: 'AO',
  },
  {
    id: 8,
    country_code: '1264',
    country_name: 'Anguilla',
    country_name_short_form: 'AI',
  },
  {
    id: 9,
    country_code: '1268',
    country_name: 'Antigua and Barbuda',
    country_name_short_form: 'AG',
  },
  {
    id: 10,
    country_code: '54',
    country_name: 'Argentina',
    country_name_short_form: 'AR',
  },
  {
    id: 11,
    country_code: '374',
    country_name: 'Armenia',
    country_name_short_form: 'AM',
  },
  {
    id: 12,
    country_code: '297',
    country_name: 'Aruba',
    country_name_short_form: 'AW',
  },
  {
    id: 13,
    country_code: '61',
    country_name: 'Australia',
    country_name_short_form: 'AU',
  },
  {
    id: 14,
    country_code: '43',
    country_name: 'Austria',
    country_name_short_form: 'AT',
  },
  {
    id: 15,
    country_code: '994',
    country_name: 'Azerbaijan',
    country_name_short_form: 'AZ',
  },
  {
    id: 16,
    country_code: '1242',
    country_name: 'Bahamas',
    country_name_short_form: 'BS',
  },
  {
    id: 17,
    country_code: '973',
    country_name: 'Bahrain',
    country_name_short_form: 'BH',
  },
  {
    id: 18,
    country_code: '880',
    country_name: 'Bangladesh',
    country_name_short_form: 'BD',
  },
  {
    id: 19,
    country_code: '+1-246',
    country_name: 'Barbados',
    country_name_short_form: 'BB',
  },
  {
    id: 20,
    country_code: '375',
    country_name: 'Belarus',
    country_name_short_form: 'BY',
  },
  {
    id: 21,
    country_code: '32',
    country_name: 'Belgium',
    country_name_short_form: 'BE',
  },
  {
    id: 22,
    country_code: '501',
    country_name: 'Belize',
    country_name_short_form: 'BZ',
  },
  {
    id: 23,
    country_code: '229',
    country_name: 'Benin',
    country_name_short_form: 'BJ',
  },
  {
    id: 24,
    country_code: '1441',
    country_name: 'Bermuda',
    country_name_short_form: 'BM',
  },
  {
    id: 25,
    country_code: '975',
    country_name: 'Bhutan',
    country_name_short_form: 'BT',
  },
  {
    id: 26,
    country_code: '591',
    country_name: 'Bolivia',
    country_name_short_form: 'BO',
  },
  {
    id: 27,
    country_code: '599',
    country_name: 'Bonaire, Saint Eustatius and Saba ',
    country_name_short_form: 'BQ',
  },
  {
    id: 28,
    country_code: '387',
    country_name: 'Bosnia and Herzegovina',
    country_name_short_form: 'BA',
  },
  {
    id: 29,
    country_code: '267',
    country_name: 'Botswana',
    country_name_short_form: 'BW',
  },
  {
    id: 30,
    country_code: '55',
    country_name: 'Brazil',
    country_name_short_form: 'BR',
  },
  {
    id: 31,
    country_code: '246',
    country_name: 'British Indian Ocean Territory',
    country_name_short_form: 'IO',
  },
  {
    id: 32,
    country_code: '1284',
    country_name: 'British Virgin Islands',
    country_name_short_form: 'VG',
  },
  {
    id: 33,
    country_code: '673',
    country_name: 'Brunei',
    country_name_short_form: 'BN',
  },
  {
    id: 34,
    country_code: '359',
    country_name: 'Bulgaria',
    country_name_short_form: 'BG',
  },
  {
    id: 35,
    country_code: '226',
    country_name: 'Burkina Faso',
    country_name_short_form: 'BF',
  },
  {
    id: 36,
    country_code: '257',
    country_name: 'Burundi',
    country_name_short_form: 'BI',
  },
  {
    id: 37,
    country_code: '855',
    country_name: 'Cambodia',
    country_name_short_form: 'KH',
  },
  {
    id: 38,
    country_code: '237',
    country_name: 'Cameroon',
    country_name_short_form: 'CM',
  },
  {
    id: 39,
    country_code: '1',
    country_name: 'Canada',
    country_name_short_form: 'CA',
  },
  {
    id: 40,
    country_code: '238',
    country_name: 'Cape Verde',
    country_name_short_form: 'CV',
  },
  {
    id: 41,
    country_code: '1345',
    country_name: 'Cayman Islands',
    country_name_short_form: 'KY',
  },
  {
    id: 42,
    country_code: '236',
    country_name: 'Central African Republic',
    country_name_short_form: 'CF',
  },
  {
    id: 43,
    country_code: '235',
    country_name: 'Chad',
    country_name_short_form: 'TD',
  },
  {
    id: 44,
    country_code: '56',
    country_name: 'Chile',
    country_name_short_form: 'CL',
  },
  {
    id: 45,
    country_code: '86',
    country_name: 'China',
    country_name_short_form: 'CN',
  },
  {
    id: 46,
    country_code: '61',
    country_name: 'Christmas Island',
    country_name_short_form: 'CX',
  },
  {
    id: 47,
    country_code: '61',
    country_name: 'Cocos Islands',
    country_name_short_form: 'CC',
  },
  {
    id: 48,
    country_code: '57',
    country_name: 'Colombia',
    country_name_short_form: 'CO',
  },
  {
    id: 49,
    country_code: '269',
    country_name: 'Comoros',
    country_name_short_form: 'KM',
  },
  {
    id: 50,
    country_code: '682',
    country_name: 'Cook Islands',
    country_name_short_form: 'CK',
  },
  {
    id: 51,
    country_code: '506',
    country_name: 'Costa Rica',
    country_name_short_form: 'CR',
  },
  {
    id: 52,
    country_code: '385',
    country_name: 'Croatia',
    country_name_short_form: 'HR',
  },
  {
    id: 53,
    country_code: '53',
    country_name: 'Cuba',
    country_name_short_form: 'CU',
  },
  {
    id: 54,
    country_code: '599',
    country_name: 'Curacao',
    country_name_short_form: 'CW',
  },
  {
    id: 55,
    country_code: '357',
    country_name: 'Cyprus',
    country_name_short_form: 'CY',
  },
  {
    id: 56,
    country_code: '420',
    country_name: 'Czech Republic',
    country_name_short_form: 'CZ',
  },
  {
    id: 57,
    country_code: '243',
    country_name: 'Democratic Republic of the Congo',
    country_name_short_form: 'CD',
  },
  {
    id: 58,
    country_code: '45',
    country_name: 'Denmark',
    country_name_short_form: 'DK',
  },
  {
    id: 59,
    country_code: '253',
    country_name: 'Djibouti',
    country_name_short_form: 'DJ',
  },
  {
    id: 60,
    country_code: '1767',
    country_name: 'Dominica',
    country_name_short_form: 'DM',
  },
  {
    id: 61,
    country_code: '1809',
    country_name: 'Dominican Republic',
    country_name_short_form: 'DO',
  },
  {
    id: 62,
    country_code: '1829',
    country_name: 'Dominican Republic',
    country_name_short_form: 'DO',
  },
  {
    id: 63,
    country_code: '670',
    country_name: 'East Timor',
    country_name_short_form: 'TL',
  },
  {
    id: 64,
    country_code: '593',
    country_name: 'Ecuador',
    country_name_short_form: 'EC',
  },
  {
    id: 65,
    country_code: '20',
    country_name: 'Egypt',
    country_name_short_form: 'EG',
  },
  {
    id: 66,
    country_code: '503',
    country_name: 'El Salvador',
    country_name_short_form: 'SV',
  },
  {
    id: 67,
    country_code: '240',
    country_name: 'Equatorial Guinea',
    country_name_short_form: 'GQ',
  },
  {
    id: 68,
    country_code: '291',
    country_name: 'Eritrea',
    country_name_short_form: 'ER',
  },
  {
    id: 69,
    country_code: '372',
    country_name: 'Estonia',
    country_name_short_form: 'EE',
  },
  {
    id: 70,
    country_code: '251',
    country_name: 'Ethiopia',
    country_name_short_form: 'ET',
  },
  {
    id: 71,
    country_code: '500',
    country_name: 'Falkland Islands',
    country_name_short_form: 'FK',
  },
  {
    id: 72,
    country_code: '298',
    country_name: 'Faroe Islands',
    country_name_short_form: 'FO',
  },
  {
    id: 73,
    country_code: '679',
    country_name: 'Fiji',
    country_name_short_form: 'FJ',
  },
  {
    id: 74,
    country_code: '358',
    country_name: 'Finland',
    country_name_short_form: 'FI',
  },
  {
    id: 75,
    country_code: '33',
    country_name: 'France',
    country_name_short_form: 'FR',
  },
  {
    id: 76,
    country_code: '594',
    country_name: 'French Guiana',
    country_name_short_form: 'GF',
  },
  {
    id: 77,
    country_code: '689',
    country_name: 'French Polynesia',
    country_name_short_form: 'PF',
  },
  {
    id: 78,
    country_code: '241',
    country_name: 'Gabon',
    country_name_short_form: 'GA',
  },
  {
    id: 79,
    country_code: '220',
    country_name: 'Gambia',
    country_name_short_form: 'GM',
  },
  {
    id: 80,
    country_code: '995',
    country_name: 'Georgia',
    country_name_short_form: 'GE',
  },
  {
    id: 81,
    country_code: '49',
    country_name: 'Germany',
    country_name_short_form: 'DE',
  },
  {
    id: 82,
    country_code: '233',
    country_name: 'Ghana',
    country_name_short_form: 'GH',
  },
  {
    id: 83,
    country_code: '350',
    country_name: 'Gibraltar',
    country_name_short_form: 'GI',
  },
  {
    id: 84,
    country_code: '30',
    country_name: 'Greece',
    country_name_short_form: 'GR',
  },
  {
    id: 85,
    country_code: '299',
    country_name: 'Greenland',
    country_name_short_form: 'GL',
  },
  {
    id: 86,
    country_code: '1473',
    country_name: 'Grenada',
    country_name_short_form: 'GD',
  },
  {
    id: 87,
    country_code: '590',
    country_name: 'Guadeloupe',
    country_name_short_form: 'GP',
  },
  {
    id: 88,
    country_code: '1671',
    country_name: 'Guam',
    country_name_short_form: 'GU',
  },
  {
    id: 89,
    country_code: '502',
    country_name: 'Guatemala',
    country_name_short_form: 'GT',
  },
  {
    id: 90,
    country_code: '441481',
    country_name: 'Guernsey',
    country_name_short_form: 'GG',
  },
  {
    id: 91,
    country_code: '224',
    country_name: 'Guinea',
    country_name_short_form: 'GN',
  },
  {
    id: 92,
    country_code: '245',
    country_name: 'Guinea-Bissau',
    country_name_short_form: 'GW',
  },
  {
    id: 93,
    country_code: '592',
    country_name: 'Guyana',
    country_name_short_form: 'GY',
  },
  {
    id: 94,
    country_code: '509',
    country_name: 'Haiti',
    country_name_short_form: 'HT',
  },
  {
    id: 95,
    country_code: '672',
    country_name: 'Heard Island and McDonald Islands',
    country_name_short_form: 'HM',
  },
  {
    id: 96,
    country_code: '504',
    country_name: 'Honduras',
    country_name_short_form: 'HN',
  },
  {
    id: 97,
    country_code: '852',
    country_name: 'Hong Kong',
    country_name_short_form: 'HK',
  },
  {
    id: 98,
    country_code: '36',
    country_name: 'Hungary',
    country_name_short_form: 'HU',
  },
  {
    id: 99,
    country_code: '354',
    country_name: 'Iceland',
    country_name_short_form: 'IS',
  },
  {
    id: 100,
    country_code: '91',
    country_name: 'India',
    country_name_short_form: 'IN',
  },
  {
    id: 101,
    country_code: '62',
    country_name: 'Indonesia',
    country_name_short_form: 'ID',
  },
  {
    id: 102,
    country_code: '98',
    country_name: 'Iran',
    country_name_short_form: 'IR',
  },
  {
    id: 103,
    country_code: '964',
    country_name: 'Iraq',
    country_name_short_form: 'IQ',
  },
  {
    id: 104,
    country_code: '353',
    country_name: 'Ireland',
    country_name_short_form: 'IE',
  },
  {
    id: 105,
    country_code: '441624',
    country_name: 'Isle of Man',
    country_name_short_form: 'IM',
  },
  {
    id: 106,
    country_code: '972',
    country_name: 'Israel',
    country_name_short_form: 'IL',
  },
  {
    id: 107,
    country_code: '39',
    country_name: 'Italy',
    country_name_short_form: 'IT',
  },
  {
    id: 108,
    country_code: '225',
    country_name: 'Ivory Coast',
    country_name_short_form: 'CI',
  },
  {
    id: 109,
    country_code: '+1-876',
    country_name: 'Jamaica',
    country_name_short_form: 'JM',
  },
  {
    id: 110,
    country_code: '81',
    country_name: 'Japan',
    country_name_short_form: 'JP',
  },
  {
    id: 111,
    country_code: '441534',
    country_name: 'Jersey',
    country_name_short_form: 'JE',
  },
  {
    id: 112,
    country_code: '962',
    country_name: 'Jordan',
    country_name_short_form: 'JO',
  },
  {
    id: 113,
    country_code: '7',
    country_name: 'Kazakhstan',
    country_name_short_form: 'KZ',
  },
  {
    id: 114,
    country_code: '254',
    country_name: 'Kenya',
    country_name_short_form: 'KE',
  },
  {
    id: 115,
    country_code: '686',
    country_name: 'Kiribati',
    country_name_short_form: 'KI',
  },
  {
    id: 116,
    country_code: '965',
    country_name: 'Kuwait',
    country_name_short_form: 'KW',
  },
  {
    id: 117,
    country_code: '996',
    country_name: 'Kyrgyzstan',
    country_name_short_form: 'KG',
  },
  {
    id: 118,
    country_code: '856',
    country_name: 'Laos',
    country_name_short_form: 'LA',
  },
  {
    id: 119,
    country_code: '371',
    country_name: 'Latvia',
    country_name_short_form: 'LV',
  },
  {
    id: 120,
    country_code: '961',
    country_name: 'Lebanon',
    country_name_short_form: 'LB',
  },
  {
    id: 121,
    country_code: '266',
    country_name: 'Lesotho',
    country_name_short_form: 'LS',
  },
  {
    id: 122,
    country_code: '231',
    country_name: 'Liberia',
    country_name_short_form: 'LR',
  },
  {
    id: 123,
    country_code: '218',
    country_name: 'Libya',
    country_name_short_form: 'LY',
  },
  {
    id: 124,
    country_code: '423',
    country_name: 'Liechtenstein',
    country_name_short_form: 'LI',
  },
  {
    id: 125,
    country_code: '370',
    country_name: 'Lithuania',
    country_name_short_form: 'LT',
  },
  {
    id: 126,
    country_code: '352',
    country_name: 'Luxembourg',
    country_name_short_form: 'LU',
  },
  {
    id: 127,
    country_code: '853',
    country_name: 'Macao',
    country_name_short_form: 'MO',
  },
  {
    id: 128,
    country_code: '389',
    country_name: 'Macedonia',
    country_name_short_form: 'MK',
  },
  {
    id: 129,
    country_code: '261',
    country_name: 'Madagascar',
    country_name_short_form: 'MG',
  },
  {
    id: 130,
    country_code: '265',
    country_name: 'Malawi',
    country_name_short_form: 'MW',
  },
  {
    id: 131,
    country_code: '60',
    country_name: 'Malaysia',
    country_name_short_form: 'MY',
  },
  {
    id: 132,
    country_code: '960',
    country_name: 'Maldives',
    country_name_short_form: 'MV',
  },
  {
    id: 133,
    country_code: '223',
    country_name: 'Mali',
    country_name_short_form: 'ML',
  },
  {
    id: 134,
    country_code: '356',
    country_name: 'Malta',
    country_name_short_form: 'MT',
  },
  {
    id: 135,
    country_code: '692',
    country_name: 'Marshall Islands',
    country_name_short_form: 'MH',
  },
  {
    id: 136,
    country_code: '596',
    country_name: 'Martinique',
    country_name_short_form: 'MQ',
  },
  {
    id: 137,
    country_code: '222',
    country_name: 'Mauritania',
    country_name_short_form: 'MR',
  },
  {
    id: 138,
    country_code: '230',
    country_name: 'Mauritius',
    country_name_short_form: 'MU',
  },
  {
    id: 139,
    country_code: '262',
    country_name: 'Mayotte',
    country_name_short_form: 'YT',
  },
  {
    id: 140,
    country_code: '52',
    country_name: 'Mexico',
    country_name_short_form: 'MX',
  },
  {
    id: 141,
    country_code: '691',
    country_name: 'Micronesia',
    country_name_short_form: 'FM',
  },
  {
    id: 142,
    country_code: '373',
    country_name: 'Moldova',
    country_name_short_form: 'MD',
  },
  {
    id: 143,
    country_code: '377',
    country_name: 'Monaco',
    country_name_short_form: 'MC',
  },
  {
    id: 144,
    country_code: '976',
    country_name: 'Mongolia',
    country_name_short_form: 'MN',
  },
  {
    id: 145,
    country_code: '382',
    country_name: 'Montenegro',
    country_name_short_form: 'ME',
  },
  {
    id: 146,
    country_code: '1664',
    country_name: 'Montserrat',
    country_name_short_form: 'MS',
  },
  {
    id: 147,
    country_code: '212',
    country_name: 'Morocco',
    country_name_short_form: 'MA',
  },
  {
    id: 148,
    country_code: '258',
    country_name: 'Mozambique',
    country_name_short_form: 'MZ',
  },
  {
    id: 149,
    country_code: '95',
    country_name: 'Myanmar',
    country_name_short_form: 'MM',
  },
  {
    id: 150,
    country_code: '264',
    country_name: 'Namibia',
    country_name_short_form: 'NA',
  },
  {
    id: 151,
    country_code: '674',
    country_name: 'Nauru',
    country_name_short_form: 'NR',
  },
  {
    id: 152,
    country_code: '977',
    country_name: 'Nepal',
    country_name_short_form: 'NP',
  },
  {
    id: 153,
    country_code: '31',
    country_name: 'Netherlands',
    country_name_short_form: 'NL',
  },
  {
    id: 154,
    country_code: '687',
    country_name: 'New Caledonia',
    country_name_short_form: 'NC',
  },
  {
    id: 155,
    country_code: '64',
    country_name: 'New Zealand',
    country_name_short_form: 'NZ',
  },
  {
    id: 156,
    country_code: '505',
    country_name: 'Nicaragua',
    country_name_short_form: 'NI',
  },
  {
    id: 157,
    country_code: '227',
    country_name: 'Niger',
    country_name_short_form: 'NE',
  },
  {
    id: 158,
    country_code: '234',
    country_name: 'Nigeria',
    country_name_short_form: 'NG',
  },
  {
    id: 159,
    country_code: '683',
    country_name: 'Niue',
    country_name_short_form: 'NU',
  },
  {
    id: 160,
    country_code: '672',
    country_name: 'Norfolk Island',
    country_name_short_form: 'NF',
  },
  {
    id: 161,
    country_code: '850',
    country_name: 'North Korea',
    country_name_short_form: 'KP',
  },
  {
    id: 162,
    country_code: '1670',
    country_name: 'Northern Mariana Islands',
    country_name_short_form: 'MP',
  },
  {
    id: 163,
    country_code: '47',
    country_name: 'Norway',
    country_name_short_form: 'NO',
  },
  {
    id: 164,
    country_code: '968',
    country_name: 'Oman',
    country_name_short_form: 'OM',
  },
  {
    id: 165,
    country_code: '92',
    country_name: 'Pakistan',
    country_name_short_form: 'PK',
  },
  {
    id: 166,
    country_code: '680',
    country_name: 'Palau',
    country_name_short_form: 'PW',
  },
  {
    id: 167,
    country_code: '970',
    country_name: 'Palestinian Territory',
    country_name_short_form: 'PS',
  },
  {
    id: 168,
    country_code: '507',
    country_name: 'Panama',
    country_name_short_form: 'PA',
  },
  {
    id: 169,
    country_code: '675',
    country_name: 'Papua New Guinea',
    country_name_short_form: 'PG',
  },
  {
    id: 170,
    country_code: '595',
    country_name: 'Paraguay',
    country_name_short_form: 'PY',
  },
  {
    id: 171,
    country_code: '51',
    country_name: 'Peru',
    country_name_short_form: 'PE',
  },
  {
    id: 172,
    country_code: '63',
    country_name: 'Philippines',
    country_name_short_form: 'PH',
  },
  {
    id: 173,
    country_code: '870',
    country_name: 'Pitcairn',
    country_name_short_form: 'PN',
  },
  {
    id: 174,
    country_code: '48',
    country_name: 'Poland',
    country_name_short_form: 'PL',
  },
  {
    id: 175,
    country_code: '351',
    country_name: 'Portugal',
    country_name_short_form: 'PT',
  },
  {
    id: 176,
    country_code: '1787',
    country_name: 'Puerto Rico',
    country_name_short_form: 'PR',
  },
  {
    id: 177,
    country_code: '1939',
    country_name: 'Puerto Rico',
    country_name_short_form: 'PR',
  },
  {
    id: 178,
    country_code: '974',
    country_name: 'Qatar',
    country_name_short_form: 'QA',
  },
  {
    id: 179,
    country_code: '242',
    country_name: 'Republic of the Congo',
    country_name_short_form: 'CG',
  },
  {
    id: 180,
    country_code: '262',
    country_name: 'Reunion',
    country_name_short_form: 'RE',
  },
  {
    id: 181,
    country_code: '40',
    country_name: 'Romania',
    country_name_short_form: 'RO',
  },
  {
    id: 182,
    country_code: '7',
    country_name: 'Russia',
    country_name_short_form: 'RU',
  },
  {
    id: 183,
    country_code: '250',
    country_name: 'Rwanda',
    country_name_short_form: 'RW',
  },
  {
    id: 184,
    country_code: '590',
    country_name: 'Saint Barthelemy',
    country_name_short_form: 'BL',
  },
  {
    id: 185,
    country_code: '290',
    country_name: 'Saint Helena',
    country_name_short_form: 'SH',
  },
  {
    id: 186,
    country_code: '1869',
    country_name: 'Saint Kitts and Nevis',
    country_name_short_form: 'KN',
  },
  {
    id: 187,
    country_code: '1758',
    country_name: 'Saint Lucia',
    country_name_short_form: 'LC',
  },
  {
    id: 188,
    country_code: '590',
    country_name: 'Saint Martin',
    country_name_short_form: 'MF',
  },
  {
    id: 189,
    country_code: '508',
    country_name: 'Saint Pierre and Miquelon',
    country_name_short_form: 'PM',
  },
  {
    id: 190,
    country_code: '1784',
    country_name: 'Saint Vincent and the Grenadines',
    country_name_short_form: 'VC',
  },
  {
    id: 191,
    country_code: '685',
    country_name: 'Samoa',
    country_name_short_form: 'WS',
  },
  {
    id: 192,
    country_code: '378',
    country_name: 'San Marino',
    country_name_short_form: 'SM',
  },
  {
    id: 193,
    country_code: '239',
    country_name: 'Sao Tome and Principe',
    country_name_short_form: 'ST',
  },
  {
    id: 194,
    country_code: '966',
    country_name: 'Saudi Arabia',
    country_name_short_form: 'SA',
  },
  {
    id: 195,
    country_code: '221',
    country_name: 'Senegal',
    country_name_short_form: 'SN',
  },
  {
    id: 196,
    country_code: '381',
    country_name: 'Serbia',
    country_name_short_form: 'RS',
  },
  {
    id: 197,
    country_code: '248',
    country_name: 'Seychelles',
    country_name_short_form: 'SC',
  },
  {
    id: 198,
    country_code: '232',
    country_name: 'Sierra Leone',
    country_name_short_form: 'SL',
  },
  {
    id: 199,
    country_code: '65',
    country_name: 'Singapore',
    country_name_short_form: 'SG',
  },
  {
    id: 200,
    country_code: '599',
    country_name: 'Sint Maarten',
    country_name_short_form: 'SX',
  },
  {
    id: 201,
    country_code: '421',
    country_name: 'Slovakia',
    country_name_short_form: 'SK',
  },
  {
    id: 202,
    country_code: '386',
    country_name: 'Slovenia',
    country_name_short_form: 'SI',
  },
  {
    id: 203,
    country_code: '677',
    country_name: 'Solomon Islands',
    country_name_short_form: 'SB',
  },
  {
    id: 204,
    country_code: '252',
    country_name: 'Somalia',
    country_name_short_form: 'SO',
  },
  {
    id: 205,
    country_code: '27',
    country_name: 'South Africa',
    country_name_short_form: 'ZA',
  },
  {
    id: 206,
    country_code: '82',
    country_name: 'South Korea',
    country_name_short_form: 'KR',
  },
  {
    id: 207,
    country_code: '211',
    country_name: 'South Sudan',
    country_name_short_form: 'SS',
  },
  {
    id: 208,
    country_code: '34',
    country_name: 'Spain',
    country_name_short_form: 'ES',
  },
  {
    id: 209,
    country_code: '94',
    country_name: 'Sri Lanka',
    country_name_short_form: 'LK',
  },
  {
    id: 210,
    country_code: '249',
    country_name: 'Sudan',
    country_name_short_form: 'SD',
  },
  {
    id: 211,
    country_code: '597',
    country_name: 'Suriname',
    country_name_short_form: 'SR',
  },
  {
    id: 212,
    country_code: '47',
    country_name: 'Svalbard and Jan Mayen',
    country_name_short_form: 'SJ',
  },
  {
    id: 213,
    country_code: '268',
    country_name: 'Swaziland',
    country_name_short_form: 'SZ',
  },
  {
    id: 214,
    country_code: '46',
    country_name: 'Sweden',
    country_name_short_form: 'SE',
  },
  {
    id: 215,
    country_code: '41',
    country_name: 'Switzerland',
    country_name_short_form: 'CH',
  },
  {
    id: 216,
    country_code: '963',
    country_name: 'Syria',
    country_name_short_form: 'SY',
  },
  {
    id: 217,
    country_code: '886',
    country_name: 'Taiwan',
    country_name_short_form: 'TW',
  },
  {
    id: 218,
    country_code: '992',
    country_name: 'Tajikistan',
    country_name_short_form: 'TJ',
  },
  {
    id: 219,
    country_code: '255',
    country_name: 'Tanzania',
    country_name_short_form: 'TZ',
  },
  {
    id: 220,
    country_code: '66',
    country_name: 'Thailand',
    country_name_short_form: 'TH',
  },
  {
    id: 221,
    country_code: '228',
    country_name: 'Togo',
    country_name_short_form: 'TG',
  },
  {
    id: 222,
    country_code: '690',
    country_name: 'Tokelau',
    country_name_short_form: 'TK',
  },
  {
    id: 223,
    country_code: '676',
    country_name: 'Tonga',
    country_name_short_form: 'TO',
  },
  {
    id: 224,
    country_code: '1868',
    country_name: 'Trinidad and Tobago',
    country_name_short_form: 'TT',
  },
  {
    id: 225,
    country_code: '216',
    country_name: 'Tunisia',
    country_name_short_form: 'TN',
  },
  {
    id: 226,
    country_code: '90',
    country_name: 'Turkey',
    country_name_short_form: 'TR',
  },
  {
    id: 227,
    country_code: '993',
    country_name: 'Turkmenistan',
    country_name_short_form: 'TM',
  },
  {
    id: 228,
    country_code: '1649',
    country_name: 'Turks and Caicos Islands',
    country_name_short_form: 'TC',
  },
  {
    id: 229,
    country_code: '688',
    country_name: 'Tuvalu',
    country_name_short_form: 'TV',
  },
  {
    id: 230,
    country_code: '1340',
    country_name: 'U.S. Virgin Islands',
    country_name_short_form: 'VI',
  },
  {
    id: 231,
    country_code: '256',
    country_name: 'Uganda',
    country_name_short_form: 'UG',
  },
  {
    id: 232,
    country_code: '380',
    country_name: 'Ukraine',
    country_name_short_form: 'UA',
  },
  {
    id: 233,
    country_code: '971',
    country_name: 'United Arab Emirates',
    country_name_short_form: 'AE',
  },
  {
    id: 234,
    country_code: '44',
    country_name: 'United Kingdom',
    country_name_short_form: 'GB',
  },
  {
    id: 235,
    country_code: '1',
    country_name: 'United States',
    country_name_short_form: 'US',
  },
  {
    id: 236,
    country_code: '1',
    country_name: 'United States Minor Outlying Islands',
    country_name_short_form: 'UM',
  },
  {
    id: 237,
    country_code: '598',
    country_name: 'Uruguay',
    country_name_short_form: 'UY',
  },
  {
    id: 238,
    country_code: '998',
    country_name: 'Uzbekistan',
    country_name_short_form: 'UZ',
  },
  {
    id: 239,
    country_code: '678',
    country_name: 'Vanuatu',
    country_name_short_form: 'VU',
  },
  {
    id: 240,
    country_code: '379',
    country_name: 'Vatican',
    country_name_short_form: 'VA',
  },
  {
    id: 241,
    country_code: '58',
    country_name: 'Venezuela',
    country_name_short_form: 'VE',
  },
  {
    id: 242,
    country_code: '84',
    country_name: 'Vietnam',
    country_name_short_form: 'VN',
  },
  {
    id: 243,
    country_code: '681',
    country_name: 'Wallis and Futuna',
    country_name_short_form: 'WF',
  },
  {
    id: 244,
    country_code: '212',
    country_name: 'Western Sahara',
    country_name_short_form: 'EH',
  },
  {
    id: 245,
    country_code: '967',
    country_name: 'Yemen',
    country_name_short_form: 'YE',
  },
  {
    id: 246,
    country_code: '260',
    country_name: 'Zambia',
    country_name_short_form: 'ZM',
  },
  {
    id: 247,
    country_code: '263',
    country_name: 'Zimbabwe',
    country_name_short_form: 'ZW',
  },
];
